import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Button, FlexGap, Heading, Radio, tokens } from '@treams/treams-ui';

const Footer = styled(Flex)`
	background: ${tokens.surface.white};
	border-top: 1px solid ${tokens.border.subtle};
`;

export function GoalSelectorVisibility(props: {
	onSelect: (shareGoal: boolean) => void;
	onBack: () => void;
}) {
	const { t } = useTranslation();
	const [shareGoal, setShareGoal] = useState<boolean | undefined>();

	return (
		<Flex flexDirection="column" flexGrow={1} width="100%">
			<Box p={3} pb={0}>
				<Heading>{t('goals.selector.header.title')}</Heading>
			</Box>
			<Box p={3} role="radiogroup">
				<FlexGap flexDirection="column" gap={tokens.gap.list}>
					<Radio.Card
						checked={shareGoal === true}
						onChange={() => setShareGoal(true)}
						title={t('goals.make-public')}
					/>
					<Radio.Card
						checked={shareGoal === false}
						onChange={() => setShareGoal(false)}
						title={t('goals.make-private')}
					/>
				</FlexGap>
			</Box>
			<Footer
				p={3}
				width="100%"
				flexGrow={0}
				flexShrink={0}
				alignItems="center"
				justifyContent="flex-end"
			>
				<Button
					type="secondary"
					title={t('goals.new.template.footer.cancel')}
					onClick={props.onBack}
				/>
				<Button
					title={t('goals.new.template.footer.continue')}
					ml={2}
					disabled={shareGoal === undefined}
					onClick={() => props.onSelect(shareGoal!)}
				/>
			</Footer>
		</Flex>
	);
}
